
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface PollsEmptyStateProps {
  countryName?: string;
  onRefresh: () => void;
}

const PollsEmptyState = ({ countryName, onRefresh }: PollsEmptyStateProps) => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-2xl font-bold text-nation-blue mb-6">Polls for {countryName}</h2>
      <div className="text-center py-6">
        <p className="text-gray-600">
          No active polls available for {countryName || "this region"}.
        </p>
        <Button onClick={onRefresh} variant="outline" className="mt-4 flex items-center">
          <RefreshCw size={16} className="mr-2" />
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default PollsEmptyState;
